<template>
  <a
    class="btn btn-default"
    @click="openAuditHistory()"
    @mousedown="hideTooltip"
    ref="historyButton"
    data-toggle="tooltip"
    data-container="body"
    title="Version History"
  >
    <i class="fa fa-history"></i>
    <span class="history-label" v-if="!hideLabel"> History</span>
  </a>
</template>

<script>
  import { mapStores } from 'pinia'
  import { useStoryAuditsStore } from '@/stores/story_audits'

  export default {
    props: {
      storyId: {
        type: Number,
        required: true
      },

      hideLabel: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapStores(useStoryAuditsStore)
    },

    methods: {
      hideTooltip() {
        if (this.$refs.historyButton) {
          jQuery(this.$refs.historyButton).tooltip('hide')
        }
      },

      openAuditHistory() {
        this.storyAuditsStore.openModal(this.storyId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .history-label {
    margin-left: 5px;
  }
</style>
